<script setup>


import notification from "@/utils/plugins/NotificationService";
import TicketForm from "@/views/internal-tickets/InternalTicketForm.vue";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import Api from "@/api/Api";
import TicketService from "@/api/services/ticket.service";
import { useUiStore } from "@/app/stores/uiStore";
import router from "@/app/router/router";
import {ref} from "vue";
import { useAuthStore } from "@/app/stores/authStore";


const authStore = useAuthStore();
const uiStore = useUiStore();


const ticket = ref({
  "phone": null,
  "equipmentTag": null,
  "issue": null,
  "description": null,
  "ticketType": null,
  "ticketPriority": null,
  "department": null,
  "project": null,
  "createdAt": new Date(),
  "comments": [],
  "ticketDocuments": [],
  "requestingEmployee": authStore.getUserLogged['@id'],
  "requestingEmployeeEmail": authStore.getUserLogged.email,
  "affectedEmployee": authStore.getUserLogged['@id'],
  "affectedEmployeeEmail": authStore.getUserLogged.email,
  "status": null,
  "isByPhone": false,
  "isOnSite": false,
  "isProjectEntity": false,
  "internal": true
})

const isSubmitting = ref(false);

const createTicket = (form, pendingFiles = []) => {
  if (isSubmitting.value) {
    return;
  }
  isSubmitting.value = true;
  const formTicket = JSON.parse(JSON.stringify(form));
  formTicket.ticketType = form.ticketType ? typeof form.ticketType === 'object' ? form.ticketType['@id'] : form.ticketType : null;
  formTicket.ticketPriority = form.ticketPriority ? form.ticketPriority : null;
  formTicket.department = form.department ? form.department : null;
  formTicket.project = form.project ? typeof form.project === 'object' ? form.project['@id'] : form.project : null;
  formTicket.affectedEmployee = form.affectedEmployee ? form.affectedEmployee : null;
  formTicket.assignedEmployee = form.assignedEmployee ? typeof form.assignedEmployee === 'object' ? form.assignedEmployee['@id'] : form.assignedEmployee : null;
  formTicket.requestingEmployee = form.requestingEmployee && typeof form.requestingEmployee === 'object' ? form.requestingEmployee['@id'] : form.requestingEmployee;

  delete (formTicket.status)
  delete (formTicket.daysOpen)
  delete (formTicket.comments)
  // Los adjuntos no van en el ticket: se suben aparte a /api/tickets/{id}/documents
  delete (formTicket.ticketDocuments)

  uiStore.startLoading();
  Api().post('/api/tickets', formTicket).then(async (res) => {
    const failedFiles = await TicketService.uploadTicketDocuments(res.data.id, pendingFiles);
    if (failedFiles.length) notification.addNotification({ title: "Adjuntos", message: "El ticket se ha creado, pero no se han podido subir: " + failedFiles.join(", ") + ". Puedes añadirlos editando el ticket.", type: "warning", duration: 15000 });
    notification.addNotification({
      title: 'Ticket creado', message: 'Ticket ' + res.data.tag + '-' + res.data.id + ' creado con éxito',
      type: 'success', duration: 10000,
    });
    router.push({ name: 'internal_tickets' });
  }).catch((error) => {
    notification.addNotification({
      title: 'Error', message: error.response?.data?.detail || error.response?.data?.message || 'No se ha podido crear el ticket.',
      type: 'error', duration: 6000,
    });
  }).finally(() => {
    uiStore.stopLoading();
    isSubmitting.value = false;
  })
}

</script>

<template>
  <div>
    <HeaderTitle title="Comunicación"/>
    <TicketForm
        v-if="ticket"
        action="create"
        :ticket="ticket"
        :isSubmitting="isSubmitting"
        @saveData="createTicket"
    />
  </div>
</template>

<style scoped>

</style>
